export const IconArrowBottom = ({size = 14}: { size?: number }) => {
    return <svg width={size}  viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7 15.5L13.25 9.25L12.3688 8.36875L7.625 13.1062L7.625 0.5L6.375 0.499999L6.375 13.1062L1.63125 8.36875L0.750001 9.25L7 15.5Z"
            fill="currentColor"/>
    </svg>

}